import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { QuestionWrapper } from 'common/components';
import { ClientForm } from 'common/forms';

import { QuestionTitle, PageControls } from '../../../../components';
import { ClientFormValues } from '../../../../../../common/models/Forms';
import { useDispatch, useSelector } from 'react-redux';
import { FormikProps } from 'formik';
import { selectInformationsCustomerInfo2, setInformationsClient2InfoValuesAction } from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function CustomerInfo2Feature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectInformationsCustomerInfo2);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } = useFormStepContinueRef<ClientFormValues>();

  function handleSkip() {
    navigate(`/form/${id}/investing`);
  }

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<ClientFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: ClientFormValues) {
    if (!isPrivileged) {
      dispatch(setInformationsClient2InfoValuesAction(values));
    }
    navigate(`/form/${id}/investing`);
  }

  return (
    <>
      <QuestionTitle>{t('informationsFeature.clientTwo')}</QuestionTitle>
      <QuestionWrapper>
        <ClientForm initialValues={initialValues || undefined} onSubmit={handleSubmit} bindSubmit={bindSubmit} />
      </QuestionWrapper>
      <PageControls
        softContinueHint={showSoftContinueHint}
        onSkip={handleSkip}
        onBack={handleBackClick}
        onContinue={handleContinueClick}
      />
    </>
  );
}
